import styled from "styled-components";

export const HeaderIcon = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
